export default "__VITE_PUBLIC_ASSET__93a7fb9c__"